import { format } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

// Utility function
// Utility function
export const formatTimeInUserTimezone = (
  timestamp: string,
  formatString = "hh:mm a zzz",
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
) => {
  try {
    return formatInTimeZone(new Date(timestamp), timezone, formatString);
  } catch (error) {
    // Fallback to local time if timezone conversion fails
    return format(new Date(timestamp), formatString);
  }
};
